
import { useEffect } from 'react'
import Select from 'react-select'
import { ProjectNameDDLAPI, ProjectTypeNameDDLAPI, ReportProjectNameDDLAPI, ReportProjectTypeDDLAPI, ReportWardNameDDLAPI, SectorDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const ReportWardNameDataDDL = (props) => {
    const { ReportWardName, setReportWardName, ReportProjectType, ReportProjectName, PopUpField, rowData, Flag,isCompulsory } = props

    // console.log(rowData)

    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            UserID,
            token,
            M_ProjectTypeID: ReportProjectType.ID,
            ProjectID: ReportProjectName.ID
        }
        dispatch(ReportWardNameDDLAPI({ data }))
    }, [ReportProjectType.ID, ReportProjectName.ID])

    const { ReportWardNameData } = useSelector(state => state.ReportWardNameDDLData)

    useEffect(() => {
        handleProjectDDL()
    }, [ReportWardNameData])

    const handleProjectDDL = () => {
        // console.log(DeptDDLDataa)
        if (ReportWardNameData && ReportWardNameData.table && ReportWardNameData.table.length > 0) {
            let list = ReportWardNameData.table.map((item, index) => ({
                value: item.id,
                label: item.wardName,
            }))

            setReportWardName({
                DDL: list,
                ID:  0,
                Label: "Select...",
            })
        }
        else {
            setReportWardName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Ward Name {(Flag || isCompulsory)&& <AstricSign />} </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: ReportWardName.ID, label: ReportWardName.Label }}
                onChange={(e) => {
                    e ?
                        setReportWardName({ ...ReportWardName, ID: e.value, Label: e.label })
                        :
                        setReportWardName({ ...ReportWardName, ID: 0, Label: "Select..." })

                }}
                options={ReportWardName.DDL}
            />
        </div>
    )
}